
export default {
  SubjectType: {
    //题目类型
    None: -1, //无
    SingleSelect: 0, //单选题
    MultiSelect: 1, //多选题
    Check: 2, //判断题
    Text: 3, //问答题
    Memo: 4, //案例题
    SingleText: 5, //填空题
    MultiGuess: 6, //不定项
    Relation: 7 //综合分析题
  },
  SubjectShowTime: {
    //做题模式
    Test: 0, //练习
    Examination: 1, //正式考试
    View: 2, //查看解析
    RedoError: 3, //错题重做
    TestInCollect: 4, //在收藏列表中练习
    TestInError: 5, //在错误列表中练习
    TestInWriteNote: 6, //在笔记列表中练习
    TestInEbbinghaus: 8 //在艾宾浩斯列表中练习
  },
  ExamShowTime: {
    //考试类型
    Exam: 0, //考试
    Error: 1, //错题重做
    View: 2 //解析
  },
  SubjectErrType: {
    //错误类型
    UnDo: 1, //待解决
    Do: 2 //已解决
  },
  SubjectErrObj: {
    //错误对象
    Chapter: 0, //章节
    Number: 1, //次数
    Cycle: 2 //周期
  },
  SubjectShowModelType: {
    //显示模块
    Content: 0, //题目内容
    List: 1, //答题情况
    WriteNote: 2, //笔记
    Error: 3, //纠错
    Setting: 4, //设置
    Clear: 5, //清空题库
    ExamResult: 6 //考试结果
  },
    
  getNavigationBarStyle(myset){
    var bgcolor = "#29aae3";
    var forecolor ="#fff";
    var webbgcolor = "#fff";
    var webforecolor = "#000";
    var bottombgcolor = "#fff";
    var	buttonbgcolor = "#f4f4f4";
    var buttoncolor = "#29aae3";
    var bordercolor = "#eee";
    var nightmode = false;
    var greenmode = false;
    
    if (myset) {
      if(myset.NightMode == "1"){
        bgcolor = "#35424b";
        forecolor = "#999";
        webbgcolor = "#1f282f";
        webforecolor = "#999";
        bottombgcolor = "#35424b";
        bordercolor = "#444";
        buttonbgcolor = "#5d6266";
        buttoncolor = "#ccc";
        nightmode = true;
      }
      else if(myset.GreenMode && myset.GreenMode == "1"){
        bgcolor = "#c7ddd0";
        forecolor = "#57695d";
        webbgcolor = "#c7ddd0";
        webforecolor = "#57695d";
        bottombgcolor = "#c7ddd0";
        bordercolor = "#c7ddd0";
        buttonbgcolor = "#c7e4d3";
        buttoncolor = "#57695d";
        greenmode = true;
      }		
    }
    
    return {
      bgcolor:bgcolor, 
      forecolor:forecolor, 
      webbgcolor:webbgcolor,
      webforecolor:webforecolor, 
      bottombgcolor:bottombgcolor,
      bordercolor:bordercolor, 
      buttonbgcolor:buttonbgcolor,
      buttoncolor:buttoncolor, 
      nightmode:nightmode, 
      greenmode:greenmode};
  },
};



// WEBPACK FOOTER //
// ./src/components/until/Global.vue